<template>
  <div class="line-between">
    <div class="side-line" :style="{ width: customWidth }"></div>
    <span v-text="lineText" class="line-text"></span>
    <div class="side-line" :style="{ width: customWidth }"></div>
  </div>
</template>
<script>
export default {
  props: {
    //分隔线文字
    lineText: {
      type: String
    },
    customWidth: {
      type: String
    }
  },
  methods: {}
};
</script>
<style lang="less">
.line-between {
  display: flex;
  min-height: 26px;
  //设置横向居中对齐
  justify-content: center;
  align-items: flex-start;
  .side-line {
    min-height: 13px;
    border-bottom: 1px solid #dde3f0;
  }
  .line-text {
    color: #939393;
    margin: 0 20px;
  }
}
</style>
